export default __webpack_public_path__ + "static/media/Group8397.243a0d60.svg";